import React, { useState } from "react";
import { Outlet, useLocation } from "react-router-dom";
import { Sidebar } from "./Sidebar";
import { Header } from "./Header";
import { ForcePasswordChange } from "./ForcePasswordChange";
import { useApp } from "@/context/AppContext";
import { Eye } from "lucide-react";

const titleMap = (t) => ({
  "/dashboard": t("dashboard"), "/sales": t("sales"), "/products": t("products"),
  "/branches": t("branchManagement"), "/organization": t("orgProfile"),
  "/users": t("userManagement"), "/roles": t("roleManagement"), "/permissions": t("permissions"),
  "/access-control": t("accessControl"), "/audit-logs": t("auditLogs"), "/notifications": t("notifications"),
  "/settings": t("settings"), "/profile": t("myProfile"),
});

export function AppLayout() {
  const [open, setOpen] = useState(false);
  const { t, user, activeBranch, isOrgView } = useApp();
  const location = useLocation();
  const title = titleMap(t)[location.pathname] || t("dashboard");
  const showSuperBanner = user?.is_super_admin && activeBranch;

  return (
    <div className="flex min-h-screen bg-background">
      <Sidebar open={open} onClose={() => setOpen(false)} />
      <div className="flex-1 min-w-0 flex flex-col">
        <Header onMenu={() => setOpen(true)} title={title} />
        {showSuperBanner && (
          <div className="bg-secondary text-white px-4 sm:px-6 py-2 flex items-center gap-2 text-xs font-semibold" data-testid="super-admin-banner">
            <Eye className="h-4 w-4" />
            {t("superAdminViewing")} {activeBranch.name.toUpperCase()}
          </div>
        )}
        <main className="flex-1 p-4 sm:p-6 max-w-[1600px] w-full">
          <Outlet />
        </main>
      </div>
      <ForcePasswordChange />
    </div>
  );
}
